// extracted by mini-css-extract-plugin
export default {"taskGroup":"IssueTaskGroup_taskGroup__NE67F","taskGroupHeader":"IssueTaskGroup_taskGroupHeader__ysFw5","taskGroupContent":"IssueTaskGroup_taskGroupContent__Fu+lN"};